import styled from 'styled-components'

export const MasterScheduleWrapper = styled.div`
  .filter-box:nth-child(2) {
    & > div:last-child {
      margin-right: 0;
    }
  }
`



// WEBPACK FOOTER //
// ./src/Components/City/Page/MasterSchedule/index.js